// extracted by mini-css-extract-plugin
export var askAiIcon = "_of-j";
export var category = "_of-9";
export var categoryHeader = "_of-e";
export var container = "_of-0";
export var group = "_of-a";
export var groupItems = "_of-f";
export var groupSeparator = "_of-k";
export var loading = "_of-1";
export var noResults = "_of-3";
export var placeholder = "_of-2";
export var resultContent = "_of-5";
export var resultIcon = "_of-c";
export var resultItem = "_of-g";
export var resultMeta = "_of-8";
export var resultSubtitle = "_of-7";
export var resultSuffix = "_of-i";
export var resultTitle = "_of-6";
export var resultsList = "_of-4";
export var searchGroup = "_of-d";
export var selected = "_of-h";
export var subgroup = "_of-b";